/** @jsx jsx */
import { jsx } from '@emotion/core'
import { Badge, Tabs } from 'antd-mobile'
import { GAME_TYPE } from '@game-type/game-market-types'
import useRootStore from '@store/useRootStore'
import { Models } from 'rmc-tabs/lib/Models'
import * as _ from 'lodash'
import * as Utils from '@utils/utils'
import { loadOrReload } from '@utils/utils'
import { Fragment, useEffect, useRef } from 'react'
import { BadgeStyle } from '@styles/base.style'
import { observer } from 'mobx-react'
import { ProducerType } from '@game-type/betradar-type'
import { SPORTS_TYPE } from '@interface/common'


export const GAME_TAB_LIST = [
  {
    title: <span className="txt">스포츠</span>,
    name: '스포츠',
    key: GAME_TYPE.CROSS,
  },
  {
    title: <span className="live-txt txt">라이브</span>,
    name: '라이브',
    key: GAME_TYPE.LIVE,
  },
]

function getGameKey(category) {
  return GAME_TAB_LIST[category].key
}

function GameTab() {
  const { matchupStore, routerStore, oddsStore, authStore, userStore, componentStore, logStore } = useRootStore()
  const { categoryTab, club = {}, currentGameKey } = matchupStore
  const { notificationData } = userStore
  const { id: clubId } = club

  const location = routerStore.location
  const prevGameTypeRef = useRef<string | null>(null)

  const liveTab = _.find(GAME_TAB_LIST, { key: GAME_TYPE.LIVE })
  if (liveTab) {
    if (matchupStore.isAvailableLiveMatch(clubId, currentGameKey)) {
      liveTab.title = (
        <Fragment>
          <span className="live-txt txt">라이브</span>
          <Badge
            text={notificationData ? notificationData.liveMatchCount : 0}
            overflowCount={99}
            css={BadgeStyle}
            className="left-tab-badge live-badge"
          />
        </Fragment>
      )
    } else {
      liveTab.title = <span className="live-txt txt">라이브</span>
    }
  }

  useEffect(() => {
    const pathName = location.pathname
    let currentGameType = ''

    if (pathName.includes(GAME_TYPE.LIVE)) {
      currentGameType = GAME_TYPE.LIVE
    } else if (pathName.includes(GAME_TYPE.CROSS)) {
      currentGameType = GAME_TYPE.CROSS
    } else {
      return
    }

    if (prevGameTypeRef.current !== currentGameType) {
      if (currentGameType === GAME_TYPE.LIVE) {
        matchupStore.setCategoryTab(1, GAME_TYPE.LIVE, true)
        matchupStore.setSportTab(1, SPORTS_TYPE.TODAY, _.toNumber(SPORTS_TYPE.TODAY))
      } else if (currentGameType === GAME_TYPE.CROSS) {
        matchupStore.setCategoryTab(0, GAME_TYPE.CROSS, true)
        matchupStore.setSportTab(0, SPORTS_TYPE.HOT, _.toNumber(SPORTS_TYPE.HOT))
      }

      prevGameTypeRef.current = currentGameType
    }
  }, [location.hash, location.pathname])

  const onTabGameChanged = async (td: Models.TabData, idx: number): Promise<void> => {
    if (td.key === GAME_TYPE.LIVE) {
      logStore.writeButtonLog({ pageId: 'b020', buttonId: '001' }).catch(console.error)
    }
    // matchupStore.cleanup()
    const gameKey = getGameKey(idx)
    const pathName = routerStore.location.pathname
    if (pathName) {
      const [, pageName, tabName, clubId] = pathName.split('/')
      const gameTypeKey = _.find(GAME_TAB_LIST, { key: tabName as GAME_TYPE })
      if (gameTypeKey) {
        const hashParameters = Utils.getAllHashParameters(true)
        loadOrReload(`/${pageName}/${gameKey}/${clubId}${hashParameters}`, false)
      }
    }

    matchupStore.setCategoryTab(idx, gameKey, true)
    if (gameKey !== GAME_TYPE.LIVE) {
      oddsStore.cleanup()
    }

    authStore.checkAdultAuthentication().catch(console.error)
    componentStore.updateIsVisibleEtcAlertOptions()
    componentStore.setIsGoToFirstScrollOfSportTab(true)

    if (gameKey === GAME_TYPE.LIVE) {
      if(_.find(matchupStore.cart, item => item.producerId === ProducerType.LIVEODDS)) {
      matchupStore.testChangeRate(matchupStore.cart, true).catch(console.error)
      }
    }
  }

  return (
    <Tabs
      tabs={GAME_TAB_LIST}
      initialPage={categoryTab}
      page={categoryTab}
      onChange={onTabGameChanged}
      prefixCls={'match-tab am-tabs'}
    />
  )
}

export default observer(GameTab)
